export default "__VITE_ASSET__DuKYHXus__"